import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.calendar').factory('EventDefaultsService', ["$rootScope", "FeatureAvailabilityService", "EmploymentService", function($rootScope, FeatureAvailabilityService, EmploymentService) {
  var attendanceAvailable;
  attendanceAvailable = FeatureAvailabilityService.isAvailable('attendance');
  return {
    build: function(params) {
      var timestamp;
      timestamp = (params != null ? params.time : void 0) ? moment.unix(params.time) : this.getRoundedTime(moment());
      return {
        start_date: timestamp.format('YYYY-MM-DD'),
        start_time: timestamp,
        end_time: this.getEndTime(timestamp),
        repeat_interval_unit: 'week',
        wdays: [moment().day()],
        repeat_interval_number: 1,
        website_hidden: !attendanceAvailable,
        show_in_kiosk_mode: attendanceAvailable,
        show_in_book_and_pay: attendanceAvailable,
        show_in_roll_call: attendanceAvailable,
        free_class: false,
        color: colorPickerColors[0]
      };
    },
    buildSchedule: function(params, eventDefaults = []) {
      var eventDefault;
      eventDefault = this.getEventDefault(eventDefaults);
      return this.buildScheduleFromTemplate(params, eventDefault);
    },
    buildScheduleFromTemplate: function(params, eventDefault) {
      var data, gymBookingDetail, instructorIds, permissions, timestamp;
      gymBookingDetail = $rootScope.gym.gym_booking_detail;
      permissions = EmploymentService.get().permissions;
      timestamp = (params != null ? params.time : void 0) ? moment.unix(params.time) : this.getRoundedTime(moment());
      instructorIds = permissions.manage_other_contacts ? [] : [window.currentUser.id];
      data = {
        rootObjectName: 'event_schedule',
        start_date: timestamp.format('YYYY-MM-DD'),
        start_at_obj: timestamp.toDate(),
        start_at: timestamp.format('YYYY-MM-DD HH:mm:ss'),
        end_at_obj: this.getEndTime(timestamp).toDate(),
        end_at: this.getEndTime(timestamp).format('YYYY-MM-DD HH:mm:ss'),
        wdays: [moment().day()],
        repeat_interval_number: 1,
        website_hidden: !attendanceAvailable,
        show_in_kiosk_mode: attendanceAvailable,
        show_in_book_and_pay: attendanceAvailable,
        show_in_roll_call: attendanceAvailable,
        free_class: false,
        event_type_ids: [],
        style_ids: [],
        instructor_ids: instructorIds,
        color: colorPickerColors[0],
        cancel_before_number: gymBookingDetail.cancel_before_number_default || 1,
        cancel_before_unit: gymBookingDetail.cancel_before_unit_default || 'day',
        bookings_allowed_before_number: gymBookingDetail.bookings_allowed_before_number_default || 1,
        bookings_allowed_before_unit: gymBookingDetail.bookings_allowed_before_unit_default || 'day',
        bookings_allowed_after_number: gymBookingDetail.bookings_allowed_after_number_default || 1,
        bookings_allowed_after_unit: gymBookingDetail.bookings_allowed_after_unit_default || 'hour',
        restrict_bookings_after: gymBookingDetail.restrict_bookings_after,
        restrict_bookings_before: gymBookingDetail.restrict_bookings_before,
        restrict_cancellations: gymBookingDetail.restrict_cancellations,
        participant_limit: 10,
        prospect_participant_limit: 0
      };
      angular.extend(data, this.getEventFromTemplate(eventDefault));
      return data;
    },
    getRoundedTime: function(moment, roundMinutes = 15) {
      var hourParts, minutes, timestamp;
      timestamp = moment.clone();
      minutes = timestamp.minute();
      hourParts = Math.ceil(minutes / roundMinutes);
      if (hourParts === 60 / roundMinutes) {
        timestamp.add(1, 'hours');
      }
      timestamp.minutes((hourParts * roundMinutes) % 60);
      return timestamp;
    },
    getEndTime: function(startTime) {
      var endTime, lastSlot;
      lastSlot = startTime.clone().hours(23).minutes(45);
      endTime = startTime.clone().add(1, 'hours');
      if (endTime.isBefore(lastSlot)) {
        return endTime;
      } else {
        return lastSlot;
      }
    },
    getEventDefault: function(eventDefaults = [], eventDefaultId) {
      var eventDefault, gymDefault, userDefault;
      if (eventDefaultId) {
        eventDefault = _.find(eventDefaults, function(item) {
          return item.id === eventDefaultId;
        });
        if (eventDefault) {
          return eventDefault;
        }
      }
      userDefault = _.find(eventDefaults, function(eventDefault) {
        return eventDefault.user_default;
      });
      if (userDefault) {
        return userDefault;
      }
      gymDefault = _.find(eventDefaults, function(eventDefault) {
        return eventDefault.gym_default;
      });
      if (gymDefault) {
        return gymDefault;
      }
    },
    getEventFromTemplate: function(template) {
      var event, keys;
      if (!template) {
        return {};
      }
      keys = ['id', 'user_default', 'gym_default', 'created_at', 'template_name', 'errors', 'creator_name', 'creator_id'];
      event = _.omit(template, keys);
      event.name = template.event_name;
      event.repeat_type = (function() {
        switch (false) {
          case !template.repeat_until_date:
            return 'until';
          case !template.infinite:
            return 'infinite';
          default:
            return 'count';
        }
      })();
      event.daily_sessions = _.mapObject(event.daily_sessions || {}, function(val, key) {
        return val.map(function(item) {
          item.start_at_obj = moment(item.start_at, 'h:mma').toDate();
          item.end_at_obj = moment(item.end_at, 'h:mma').toDate();
          return item;
        });
      });
      return event;
    }
  };
}]);
